var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full overflow-x-auto overflow-y-hidden"},[_c('nav',{staticClass:"flex flex-wrap "},_vm._l((_vm.tabs),function(item,index){return _c('anchor-tab-item',{key:index,attrs:{"item":item}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }